import { useEffect, useState, useRef } from "react";
import useAxios from '../../hooks/useAxios';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from 'primereact/button';
import { Fieldset } from "primereact/fieldset";
import { Panel } from "primereact/panel";
import { Checkbox } from "primereact/checkbox";
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import MsisdnSearch from '../../components/MsisdnSearch';


function ARDs() {
  const [msisdn, setMsisdn] = useState(992);
  const [imsi, setImsi] = useState();
  const [ards, setArds] = useState({});
  const [initialData, setInitialData] = useState({});
  const [ardsChanged, setArdsChanged] = useState(false);

  const { user } = useAuth();
  const { response, error, setError, loading, fetchData } = useAxios();
  const toast = useRef(null);

  useEffect(() => {
    if (!response) return;

    // Show toast for both success and error messages
    if (response.message) {
      const severity = response.status === "error" ? "error" : response.status;
      toast.current.show({ severity, detail: response.message, life: 3000 });
    }

    // Only update data on success
    if (response.status === "success" && response.data) {
      setInitialData({ imsi: response.data.imsi, ards: response.data.ards });
      setArds(response.data.ards);
      setImsi(response.data.imsi);
    } else if (response.status === "error") {
      // Clear data on error
      setInitialData({});
      setArds({});
      setImsi();
    }
  }, [response]);


  const handleSearch = (msisdnValue) => {
    setMsisdn(msisdnValue);
    fetchData({ method: 'get', url: '/api/summa-ards', params: { msisdn: msisdnValue } });
  };


  const handleArdChange = (e) => {
    //setArds({ ...ards, [e.target.name.split("-")[0]]: { ...ards[e.target.name.split("-")[0]], [e.target.name.split("-")[1]]: e.checked } });
    setArds({ ...ards, [e.target.name]: e.checked });
  };




  useEffect(() => {
    if (initialData?.ards) {
      setArdsChanged(JSON.stringify(ards) !== JSON.stringify(initialData.ards));
    }
    console.log(ards);

  }, [ards, initialData]);


  const handleSubmitUpdateForm = async (e) => {
    e.preventDefault();
    try {
      fetchData({ method: 'post', url: '/api/summa-ards', data: { imsi: imsi, ards: ards } });
    } catch (error) {
      console.log(error);
    }
  };


  const sendCancelLocation = (e) => {
    e.preventDefault();
    try {
      fetchData({ method: 'post', url: '/api/summa-send-cancel-location', data: { imsi: imsi } });
    } catch (error) {
      console.log(error);
    }
  }

  if (!user) return null;

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <MsisdnSearch onSubmit={handleSearch} loading={loading} title="Блокировка сетей" description="Управление блокировкой сетей ARD по номеру MSISDN" />

      {imsi && (
        <>
          <div className="px-3 mt-5">
            <Divider className="my-4" />
            <form onSubmit={handleSubmitUpdateForm}>

              <Panel header="Запреты" className="mt-4" style={{ fontSize: '0.80rem' }}>
                <Fieldset legend="Запреты доступа в сеть" style={{ fontSize: '0.80rem', padding: '0.5rem' }}>
                  <div className="flex flex-wrap gap-4">
                    <div className="flex align-items-center">
                      <Checkbox inputId="csGeranNotAllowed" name="geranNotAllowed" onChange={handleArdChange} checked={ards.geranNotAllowed} />
                      <label htmlFor="csGeranNotAllowed" className="ml-2">2G</label>
                    </div>
                    <div className="flex align-items-center">
                      <Checkbox inputId="csUtranNotAllowed" name="utranNotAllowed" onChange={handleArdChange} checked={ards.utranNotAllowed} />
                      <label htmlFor="csUtranNotAllowed" className="ml-2">3G</label>
                    </div>
                    <div className="flex align-items-center">
                      <Checkbox inputId="csEutranNotAllowed" name="eutranNotAllowed" onChange={handleArdChange} checked={ards.eutranNotAllowed} />
                      <label htmlFor="csEutranNotAllowed" className="ml-2">4G</label>
                    </div>
                  </div>
                </Fieldset>

                <Fieldset legend="Запреты передачи данных" className="mt-4" style={{ fontSize: '0.85rem', padding: '0.5rem' }}>
                  <div className="flex flex-wrap gap-4">
                    <div className="flex align-items-center">
                      <Checkbox inputId="odbHlr" name="odbHlr" onChange={handleArdChange} checked={ards.odbHlr} invalid={ards.odbHlr === "invalid"} disabled={ards.odbHlr === "invalid"} />
                      <label htmlFor="odbHlr" className="ml-2">2G/3G</label>
                    </div>
                    <div className="flex align-items-center">
                      <Checkbox inputId="odbLte" name="odbLte" onChange={handleArdChange} checked={ards.odbLte} invalid={ards.odbLte === "invalid"} disabled={ards.odbLte === "invalid"} />
                      <label htmlFor="odbLte" className="ml-2">4G</label>
                    </div>
                  </div>
                </Fieldset>
              </Panel>

              <div className='p-fluid grid formgrid mt-5'>
                <div className="col-6">
                  <Button label="Сохранить изменения" className="p-button-primary w-full" raised disabled={!ardsChanged} />
                </div>

                <div className="col-6">
                  <Button type="button" label="Послать команду cancel" className="p-button-primary w-full" raised onClick={sendCancelLocation} />
                </div>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  );
}



export default ARDs;